<div class="absolute inset-0 flex flex-col min-w-0 overflow-y-auto" cdkScrollable>
  <div class="flex-auto p-2 sm:p-4 bg-gray-100">
    <div class="flex flex-col space-y-2">
      <div class="flex items-center space-x-2 py-3">
        <button mat-icon-button matTooltip="Voltar" routerLink="../../">
          <mat-icon svgIcon="heroicons_outline:arrow-left"></mat-icon>
        </button>
        <span class="text-2xl font-bold">
          Evolução das instalações do aplicativo
        </span>
      </div>

      <ng-container *ngIf="loading$ | async; else content">
        <div class="w-full flex justify-center py-8">
          <mat-spinner></mat-spinner>
        </div>
      </ng-container>

      <ng-template #content>
        <div class="flex flex-col space-y-2 p-4 bg-white shadow-sm rounded">
          <div class="flex flex-col">
            <span class="text-2xl font-bold">{{ total$ | async }}</span>
            <span>Instalações</span>
          </div>

          <apx-chart
            *ngIf="chartOptions$ | async as opts"
            [series]="opts.series"
            [chart]="opts.chart"
            [xaxis]="opts.xaxis"
            [dataLabels]="opts.dataLabels"
            [grid]="opts.grid"
            [stroke]="opts.stroke">
          </apx-chart>
        </div>
      </ng-template>
    </div>
  </div>
</div>
